export default {
  carrier: {
    code: "postnl",
    name: "PostNL"
  },
  delivered_at: null,
  delivery_information: [
    { type: "form_factor", value: "parcel" },
    { type: "min_age", value: 0 },
    { type: "signature", value: false }
  ],
  estimated_delivery: null,
  name: "Test ServicePoint",
  status_history: [
    {
      timestamp: "2018-09-21T08:52:00Z",
      friendly_parent_code: "ready_for_pickup",
      id: 125538623,
      message: "Awaiting customer pickup",
      friendly_message: {
        de: "Your parcel is ready for pickup",
        fr: "Your parcel is ready for pickup",
        "en-us": "Your parcel is ready for pickup",
        nl: "Your parcel is ready for pickup"
      },
      extra_data: {
        facility: "BPO",
        route: "0",
        network: { network: "DAY_DEFINITE" },
        geo_location: {},
        category: "IN_DELIVERY",
        type: "PIECE_EVENT"
      }
    },
    {
      extra_data: {},
      friendly_message: {
        de: "Out for delivery de",
        "en-us": "Out for delivery",
        fr: "Out for delivery fr",
        nl: "Out for delivery nl"
      },
      friendly_parent_code: "out_for_delivery",
      id: 4,
      timestamp: "2018-09-20T09:24:41.237275+00:00"
    },
    {
      extra_data: {},
      friendly_message: {
        de: "Departed - OK, Out for Delivery de",
        "en-us": "Departed - OK, Out for Delivery",
        fr: "Departed - OK, Out for Delivery fr",
        nl: "Departed - OK, Out for Delivery nl"
      },
      friendly_parent_code: "out_for_delivery",
      id: 3,
      timestamp: "2018-09-19T15:15:41.237275+00:00"
    },
    {
      extra_data: {},
      friendly_message: {
        de: "Arrived at receiving gateway (Sorting center) de",
        "en-us": "Arrived at receiving gateway (Sorting center)",
        fr: "Arrived at receiving gateway (Sorting center) fr",
        nl: "Arrived at receiving gateway (Sorting center) nl"
      },
      friendly_parent_code: "handled_by_carrier",
      id: 2,
      timestamp: "2018-09-17T10:03:41.237275+00:00"
    },
    {
      extra_data: {},
      friendly_message: {
        de: "Ready to send de",
        "en-us": "Ready to send",
        fr: "Ready to send fr",
        nl: "Ready to send nl"
      },
      friendly_parent_code: "received_shipment_information",
      id: 1,
      timestamp: "2018-09-17T08:55:41.237275+00:00"
    }
  ],
  to_address_1: "Insulindelaan",
  to_address_2: "",
  to_city: "Eindhoven",
  to_company_name: "SendCloud",
  to_country: { name: "Netherlands" },
  to_house_number: "115",
  to_postal_code: "5642 CV",
  to_service_point: {
    id: 1,
    name: "Primera",
    street: "Tongelresestraat",
    house_number: "276",
    postal_code: "5613DV",
    city: "Eindhoven",
    latitude: "51.441752",
    longitude: "5.502917",
    email: "",
    phone: "",
    homepage: "",
    carrier: "postnl",
    country: "NL",
    opening_times: {
      "0": ["13:00 - 18:00"],
      "1": ["09:00 - 12:00", "12:00 - 18:00"],
      "2": ["09:00 - 12:00", "12:00 - 18:00"],
      "3": ["09:00 - 12:00", "12:00 - 18:00"],
      "4": ["09:00 - 12:00", "12:00 - 18:00"],
      "5": ["09:00 - 12:00", "12:00 - 17:00"],
      "6": ["00:00 - 00:00"]
    },
    open_tomorrow: false
  },
  to_state: null,
  tracking_number: "SC1234567890",
  address_for_pickup: null
};
